// Data-driven content for the dedicated SEO landing pages.
export const FORMS = [
  { name: "TPV Letter of Authorization", url: "https://irp.cdn-website.com/de603881/files/uploaded/TPV+LOA.pdf" },
  { name: "DS-3053 — Consent for Minor", url: "https://irp.cdn-website.com/de603881/files/uploaded/ds3053.pdf" },
  { name: "DS-64 — Lost or Stolen Passport", url: "https://irp.cdn-website.com/de603881/files/uploaded/ds64_pdf.pdf" },
  { name: "DS-82 — Passport Renewal", url: "https://pptform.state.gov/FraudAbuseNotice.aspx?AspxAutoDetectCookieSupport=1" },
  { name: "Letter Requesting 2nd Passport", url: "https://irp.cdn-website.com/de603881/files/uploaded/second_passport_statement.pdf" },
];

export const SEO_PAGES = {
  "child-passport": {
    title: "Child Passport (Under 16) | Minor Passport Service Washington DC",
    metaTitle: "Child Passport Service Washington DC (Under 16) | UPV Services",
    metaDescription:
      "Getting a U.S. passport for a child under 16? UPV Services guides parents through the DS-11, DS-3053 consent, and expedited processing in Washington DC. Call 202-457-4665.",
    overline: "Passport Services",
    h1: "Child Passport Service (Under Age 16)",
    intro:
      "Passports for children have special rules — including consent from both parents or guardians. UPV Services walks families through every requirement and expedites your child's passport so your family trip stays on schedule.",
    heroImage: "passport",
    bullets: [
      "Guidance on both-parent consent & DS-3053",
      "Proof-of-citizenship and photo requirements",
      "Expedited processing for upcoming travel",
      "Friendly, step-by-step family support",
    ],
    eligibility: {
      heading: "Apply for this type of passport only if:",
      items: [
        "The applicant is under the age of 16 at the time of application.",
        "Both parents or legal guardians can appear with the child, or the required consent form (DS-3053) is provided if one parent/guardian cannot appear.",
        "The child is a U.S. citizen by birth or through naturalization/derivation.",
      ],
    },
    forms: FORMS,
    sections: [
      { h2: "Both-parent consent", body: "For children under 16, both parents or legal guardians generally must appear in person to consent. If one parent cannot appear, a notarized DS-3053 consent form is required. We'll tell you exactly which situation applies to your family and how to prepare." },
      { h2: "What to bring", body: "You'll need the child's proof of U.S. citizenship (birth certificate), both parents' photo IDs, a compliant passport photo of the child, and the completed application. We review everything before submission so nothing is missed." },
    ],
    faqKeys: ["Can you expedite a passport for a child or minor?", "What documents do I need to start my passport or visa application?", "Do I need to visit UPV Services in person to get my passport or visa processed?"],
  },
  "name-change-passport": {
    title: "Passport Name Change | Correct or Update Your U.S. Passport — DC",
    metaTitle: "Passport Name Change Service Washington DC | UPV Services",
    metaDescription:
      "Need a passport name change or correction? UPV Services expedites name-change and corrected U.S. passports in Washington DC. Call 202-457-4665.",
    overline: "Passport Services",
    h1: "Passport Name Change & Correction",
    intro:
      "Recently married, divorced, or corrected a printing error? UPV Services expedites name-change and corrected U.S. passports in Washington DC, guiding you through the exact supporting documents required.",
    heroImage: "booklet",
    bullets: [
      "Name-change passports (marriage, divorce, court order)",
      "Printing-error corrections",
      "Guidance on required supporting documents",
      "Expedited processing available",
    ],
    eligibility: {
      heading: "Apply for a new passport if:",
      items: [
        "You need to correct a printing error on your current, valid U.S. passport, or",
        "You legally changed your name within one year of your most recent passport being issued, or",
        "Your most recent U.S. passport was issued less than one year ago and needs to be replaced, corrected, or updated.",
      ],
    },
    forms: FORMS,
    sections: [
      { h2: "Which document proves your name change?", body: "Depending on your situation you'll need a certified marriage certificate, divorce decree, or court order showing the legal name change. We confirm exactly which document the passport agency will accept for your case." },
      { h2: "Corrections and recent issues", body: "If your passport has a printing error or was issued less than a year ago, you may be eligible for a corrected passport. We handle the paperwork and expedite the turnaround." },
    ],
    faqKeys: ["Can you help me change the name on my passport?", "What documents do I need to start my passport or visa application?", "How fast can UPV Services process my passport or visa?"],
  },
  "rush-passport-service": {
    title: "Rush Passport Service | Rush Passport Renewal & Visa — Washington DC",
    metaTitle: "Rush Passport Service Washington DC | Rush Renewal & Visa — UPV",
    metaDescription:
      "Need a rush passport? UPV Services delivers rush passport renewals, new passports, and rush visa processing in Washington DC — expedited in as little as 5 business days. Call 202-457-4665.",
    overline: "Rush Services",
    h1: "Rush Passport & Visa Service in Washington DC",
    intro:
      "When you need documents in a hurry, UPV Services is your rush passport and visa specialist. We rush-process new passports, renewals, and visas for travelers across DC, the East Coast, and nationwide — hand-carrying filings to the passport agency and embassies so you're ready to travel.",
    heroImage: "traveler",
    bullets: [
      "Rush passport renewals & new passports",
      "Rush visa processing for 78 countries",
      "Expedited turnaround, often within 5 business days",
      "Hand-carried filings in downtown DC",
    ],
    sections: [
      { h2: "What is rush passport service?", body: "Rush passport service means fast-tracking your application outside the slow standard government queue. As a registered expediter located steps from the passport agency, we hand-carry your paperwork and pursue the quickest compliant turnaround — frequently within 5 business days depending on your case and current agency availability." },
      { h2: "Rush passport renewals and new passports", body: "Whether you need a rush renewal, a first-time passport, or a replacement, we review every document before submission to eliminate the errors that cause government rejections and delays, then prioritize your case around your travel date." },
      { h2: "Rush visa processing", body: "Traveling internationally on short notice? We rush tourist and business visas for 78 countries, hand-delivering applications to the embassies and consulates right here in Washington DC to save you days." },
    ],
    faqKeys: ["How fast can UPV Services process my passport or visa?", "Can you help if my trip is urgent?", "What documents do I need to start my passport or visa application?"],
  },
  "first-time-passport": {
    title: "First-Time Passport Application | New US Passport Help DC",
    metaTitle: "First-Time Passport Application Washington DC | UPV Services",
    metaDescription:
      "Applying for your first US passport? UPV Services guides first-time applicants in Washington DC through the DS-11 form, photos, and acceptance — fast. Call 202-457-4665.",
    overline: "Passport Services",
    h1: "First-Time Passport Applications",
    intro:
      "Getting your very first US passport shouldn't be confusing. UPV Services walks first-time applicants in Washington DC, Maryland, and Virginia through every requirement — from the DS-11 form and citizenship proof to a compliant photo — and expedites processing so you're ready to travel.",
    heroImage: "passport",
    bullets: [
      "Step-by-step DS-11 application guidance",
      "Citizenship & identity document review",
      "Compliant passport photos on-site",
      "Expedited first-time processing available",
    ],
    sections: [
      { h2: "Who needs to apply in person?", body: "First-time adult applicants must submit their application in person at an authorized acceptance facility because you cannot renew what you've never had. We prepare your complete package in advance and tell you exactly where and how to submit so your acceptance appointment goes smoothly the first time." },
      { h2: "What documents do first-time applicants need?", body: "You'll need proof of US citizenship (a certified birth certificate or naturalization certificate), a valid photo ID, a photocopy of that ID, a compliant 2x2 passport photo, and the DS-11 form. We review each item before submission to eliminate the mistakes that cause rejections." },
      { h2: "How fast can a first-time passport be issued?", body: "With expedited handling and a documented travel date, first-time passports can be turned around far faster than the standard government timeline. Tell us when you're traveling and we'll map the quickest compliant route." },
    ],
    eligibility: {
      heading: "You may need to apply as a first-time applicant if:",
      items: [
        "You have never been issued a U.S. Passport, or",
        "Your previous passport was issued more than 15 years ago, or",
        "Your valid passport has been damaged, or",
        "Your most recent passport was issued when you were under the age of 15.",
      ],
    },
    forms: FORMS,
    faqKeys: ["What documents do I need to start my passport or visa application?", "Do I need to visit UPV Services in person to get my passport or visa processed?", "Can I get help with my application if I'm not sure what to do?"],
  },
  "second-passport": {
    title: "Second Passport Services | Two Valid US Passports — DC",
    metaTitle: "Second Passport Services Washington DC | UPV Services",
    metaDescription:
      "Frequent traveler needing two valid US passports? UPV Services processes second passport applications in Washington DC for travelers with back-to-back trips or visa processing. Call 202-457-4665.",
    overline: "Passport Services",
    h1: "Second Passport Services",
    intro:
      "Business travelers who can't be without their passport — or who need one book at an embassy while traveling on the other — can qualify for a second, limited-validity US passport. UPV Services handles the justification and paperwork so you're never grounded waiting on a visa.",
    heroImage: "booklet",
    bullets: [
      "For frequent international business travelers",
      "Travel while a visa is being processed",
      "Justification letter guidance",
      "Expedited handling in downtown DC",
    ],
    sections: [
      { h2: "Who qualifies for a second passport?", body: "Second US passports are typically issued to travelers who need to travel while their primary passport is tied up at an embassy for visa processing, or whose itineraries include countries that deny entry based on stamps from certain other nations. We help confirm your eligibility and document the need." },
      { h2: "What's required?", body: "A second passport application generally requires a completed DS-82 or DS-11, your current valid passport, a passport photo, and a signed statement explaining the business need. Our specialists prepare the justification so it meets State Department expectations." },
      { h2: "How long is a second passport valid?", body: "Second passports are usually issued with limited validity (commonly four years) rather than the standard ten. We'll explain the current terms and expedite issuance around your travel schedule." },
    ],
    eligibility: {
      heading: "A second U.S. passport can benefit frequent travelers who:",
      items: [
        "Need to travel quickly and may face time constraints obtaining visas between trips, or",
        "Require an additional passport for safety or security reasons.",
      ],
    },
    forms: FORMS,
    faqKeys: ["Do you help with international visas?", "How fast can UPV Services process my passport or visa?", "What documents do I need to start my passport or visa application?"],
  },
  "expedited-passport-service-washington-dc": {
    title: "Expedited Passport Service Washington DC | 5 Business Day Processing",
    metaTitle: "Expedited Passport Service Washington DC | UPV Services",
    metaDescription:
      "Need a passport fast in Washington DC? UPV Services delivers expedited passport processing in as little as 5 business days. 20+ years experience. Call 202-457-4665.",
    overline: "Passport Services",
    h1: "Expedited Passport Service in Washington DC",
    intro:
      "When your departure date won't wait for the standard government timeline, UPV Services fast-tracks your passport in downtown Washington DC. We hand-carry filings directly to the passport agency and guide you through every requirement so nothing delays your trip.",
    heroImage: "traveler",
    bullets: [
      "Emergency & expedited processing within 5 business days",
      "Hand-carried filings to the DC Passport Agency",
      "20+ years of expediting experience",
      "Personalized document checklist for your travel",
    ],
    sections: [
      { h2: "How fast can I get an expedited passport in DC?", body: "For urgent, life-or-death, and imminent travel situations, expedited passports can often be completed within 5 business days. Timelines depend on current agency availability and the completeness of your paperwork. Because we're located steps from the federal offices, we save you the days most applicants lose to shipping and appointment gaps." },
      { h2: "Who needs an expedited passport?", body: "Business travelers with last-minute assignments, families responding to emergencies abroad, and anyone who discovered an expired passport days before departure. Whatever the reason, our specialists prioritize your case and keep you updated at every step." },
      { h2: "What you'll need", body: "Proof of US citizenship, a government-issued photo ID, a compliant passport photo, and your travel itinerary. We review everything before submission to eliminate the errors that cause government rejections and delays." },
    ],
    faqKeys: ["How fast can UPV Services process my passport or visa?", "What documents do I need to start my passport or visa application?", "Can you help if my trip is urgent?"],
  },
  "same-day-passport-service": {
    title: "Emergency Passport Service | Fast-Track Expedited Processing DC",
    metaTitle: "Emergency Passport Service Washington DC | UPV Services",
    metaDescription:
      "Emergency travel? UPV Services fast-tracks expedited passport processing in Washington DC for urgent departures — often in as little as 5 business days. Call 202-457-4665.",
    overline: "Emergency Processing",
    h1: "Emergency & Expedited Passport Service",
    intro:
      "A missing or expiring passport days before a flight isn't the end of your trip. UPV Services specializes in emergency and expedited passport processing for travelers with imminent international departures — often in as little as 5 business days.",
    heroImage: "passport",
    bullets: [
      "Fast-track handling for imminent international travel",
      "Emergency and life-or-death case prioritization",
      "Direct access to the Washington DC Passport Agency",
      "Live specialist guidance from start to finish",
    ],
    sections: [
      { h2: "How fast can an emergency passport be issued?", body: "For travelers with proof of imminent international departure, we prioritize your case and pursue the fastest compliant turnaround available — frequently within 5 business days. Bring your travel itinerary and we'll confirm your options immediately and begin the moment you call." },
      { h2: "Why speed depends on location", body: "Being in downtown DC where the passport agency and embassies operate means we hand-carry your documents directly, avoiding the shipping and scheduling delays that slow standard processing elsewhere." },
      { h2: "Act quickly", body: "The sooner you reach us, the more options you have. Call 202-457-4665 and have your travel dates ready so we can start prioritizing your case right away." },
    ],
    faqKeys: ["Can you help if my trip is urgent?", "How fast can UPV Services process my passport or visa?", "Where can I find your office if I want to come in person?"],
  },
  "passport-renewal-washington-dc": {
    title: "Passport Renewal Washington DC | Fast Adult & Child Renewals",
    metaTitle: "Passport Renewal Washington DC | Fast Renewals — UPV Services",
    metaDescription:
      "Renew your passport fast in Washington DC. UPV Services expedites adult and child passport renewals in days, not weeks. 20+ years experience. Call 202-457-4665.",
    overline: "Passport Services",
    h1: "Passport Renewal in Washington DC",
    intro:
      "Don't lose weeks to the standard renewal process. UPV Services expedites passport renewals for DC, Maryland, and Virginia travelers — often within days — with expert review that keeps your application error-free.",
    heroImage: "booklet",
    bullets: [
      "Expedited adult and child renewals",
      "Name-change and second-passport renewals",
      "Application review before submission",
      "Serving DC, Maryland, Virginia & nationwide",
    ],
    sections: [
      { h2: "Can I renew my passport quickly?", body: "Yes. If your most recent passport is undamaged and was issued when you were 16 or older, you're generally eligible for renewal — and we can expedite it well ahead of the multi-week government standard." },
      { h2: "Renewals with a name change", body: "Recently married or legally changed your name? We handle name-change renewals and tell you exactly which supporting documents (marriage certificate, court order) are required." },
      { h2: "Child passport renewals", body: "Passports for minors have special rules, including consent from both parents. Our specialists guide families through the process so it's smooth and stress-free." },
    ],
    eligibility: {
      heading: "You may be eligible to renew your passport if:",
      items: [
        "Your previous passport was issued when you were age 16 or older, and",
        "The passport is still in your possession and is undamaged, and",
        "The passport was issued less than 15 years ago.",
      ],
    },
    forms: FORMS,
    faqKeys: ["Can I renew my passport quickly?", "What documents do I need to start my passport or visa application?", "Do I need to visit UPV Services in person to get my passport or visa processed?"],
  },
  "lost-passport-replacement": {
    title: "Lost Passport Replacement | Lost, Stolen & Damaged Passports DC",
    metaTitle: "Lost Passport Replacement Washington DC | UPV Services",
    metaDescription:
      "Lost, stolen, or damaged passport? UPV Services expedites replacements in Washington DC so you can travel on schedule. Call 202-457-4665 for urgent help.",
    overline: "Passport Services",
    h1: "Lost or Stolen Passport Replacement",
    intro:
      "Losing your passport is stressful — replacing it doesn't have to be. UPV Services expedites lost, stolen, and damaged passport replacements in Washington DC, handling the reporting requirements and paperwork so you travel on time.",
    heroImage: "passport",
    bullets: [
      "Lost, stolen, and damaged passport replacement",
      "Guidance on reporting and required forms",
      "Expedited processing for upcoming travel",
      "Compassionate, step-by-step specialist support",
    ],
    sections: [
      { h2: "What to do if your passport is lost or stolen", body: "A lost or stolen passport must be reported before a replacement can be issued. We walk you through the required statement and forms, then expedite your replacement application — even if your trip is only days away." },
      { h2: "Damaged passports", body: "Water damage, tears, or unofficial markings can invalidate a passport at the border. If yours is damaged, we'll assess it and process a replacement so you aren't turned away at check-in." },
      { h2: "Traveling soon?", body: "Replacement can be expedited for urgent departures. Call us with your travel date and we'll prioritize your case immediately." },
    ],
    eligibility: {
      heading: "Apply for a replacement only if:",
      items: [
        "Your valid passport has been lost or stolen, and",
        "You have reported it lost or stolen.",
        "If it has expired, you must apply for a new passport instead.",
      ],
    },
    forms: FORMS,
    faqKeys: ["Can you help if my trip is urgent?", "What documents do I need to start my passport or visa application?", "Is the online process secure?"],
  },
  "visa-services-washington-dc": {
    title: "Visa Services Washington DC | Business, Tourist & Embassy Visas",
    metaTitle: "Visa Services Washington DC | Embassy Visa Processing — UPV",
    metaDescription:
      "Business, tourist, and embassy visa processing in Washington DC. UPV Services hand-carries filings to DC embassies to speed up your visa. Call 202-457-4665.",
    overline: "Visa Services",
    h1: "Visa Services in Washington DC",
    intro:
      "From business trips to family vacations, UPV Services processes visas for destinations worldwide. Being in the embassy district of Washington DC lets us hand-carry your filings and secure appointments faster than remote services.",
    heroImage: "traveler",
    bullets: [
      "Business and tourist visas",
      "Embassy and consulate hand-carry filings",
      "Country-specific requirement guidance",
      "Deadline-driven processing",
    ],
    sections: [
      { h2: "Do you help with international visas?", body: "Yes. We assist with business, tourist, and country-specific visas, handling the forms, photos, and supporting documents each embassy requires. Our proximity to DC's embassies means faster submissions and pickups." },
      { h2: "Business visas on deadline", body: "Corporate travel rarely gives much notice. We process business visas quickly and coordinate directly with the relevant consulate to keep your trip on schedule." },
      { h2: "Country-specific assistance", body: "Every country has its own visa rules. Tell us your destination and we'll provide a precise checklist and manage the filing so nothing gets rejected." },
    ],
    faqKeys: ["Do you help with international visas?", "What documents do I need to start my passport or visa application?", "How fast can UPV Services process my passport or visa?"],
  },
  "apostille-services-dc": {
    title: "Apostille Services DC | Document Authentication Washington DC",
    metaTitle: "Apostille Services DC | Document Authentication — UPV Services",
    metaDescription:
      "Apostille and document authentication in Washington DC for international use. UPV Services processes State Department authentications fast. Call 202-457-4665.",
    overline: "Document Services",
    h1: "Apostille & Document Authentication in DC",
    intro:
      "Documents used abroad often require an apostille or authentication. UPV Services processes apostilles through the US Department of State and DC authorities so your legal, business, and personal documents are accepted internationally.",
    heroImage: "booklet",
    bullets: [
      "Apostille for Hague Convention countries",
      "US Department of State authentication",
      "Certified translations available",
      "Notary services on-site in downtown DC",
    ],
    sections: [
      { h2: "What is an apostille?", body: "An apostille certifies the authenticity of a document so it's recognized in countries that are part of the Hague Convention. Common documents include birth and marriage certificates, powers of attorney, diplomas, and corporate records." },
      { h2: "Authentication for non-Hague countries", body: "For countries outside the Hague Convention, documents require a chain of authentication that may include the State Department and the destination country's embassy. We manage the entire chain for you." },
      { h2: "Translations and notary", body: "Need a certified translation or notarization first? We offer both on-site so your documents are fully prepared before authentication." },
    ],
    faqKeys: ["What documents do I need to start my passport or visa application?", "Is the online process secure?", "Where can I find your office if I want to come in person?"],
  },
};

export const SEO_SLUGS = Object.keys(SEO_PAGES);
